const $ = jQuery.noConflict();

$(document).ready(function () {

  // open cookie settings
  waitForElement('.cassie-pre-banner--button.cassie-view-all').then((el) => {
    el.addEventListener ('click', () => {
      cookieSettingsOpen ();
    });
  });

  waitForElement('.cassie-manage-cookies--button').then((el) => {

    // open cookie policy
    document.querySelector('.cookie-policy-setting').addEventListener('click', (e) => {
      e.preventDefault();
      el.click();
    });

    el.addEventListener ('click', () => {
      cookieSettingsOpen ();
    });
  });

  // close cookie settings
  waitForElement('.cassie-close-modal-button').then((el) => {
    el.addEventListener ('click', () => {
      cookieSettingsClose ();
    });
  });
});


function waitForElement (selector) {
  return new Promise(resolve => {

    // Check if it already exists
    const element = document.querySelector(selector);
    if (element) {
      return resolve(element);
    }

    // Otherwise, watch the DOM for changes
    const observer = new MutationObserver(() => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
        observer.disconnect(); // Stop watching once found
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

function cookieSettingsOpen () {
  let settingsModal = document.querySelector ('.cassie-cookie-module');
  settingsModal.classList.add('open');
}

function cookieSettingsClose () {
  let settingsModal = document.querySelector ('.cassie-cookie-module');
  settingsModal.classList.remove('open');
}
